import { Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useSelector } from 'react-redux';
import { projectRole } from '@model';

export const Dropdown = ({
  title,
  sendData,
  list,
  isViewMode,
  onTitleChange,
  isLeftPartEditing,
}) => {
  const [isDropDownOpen, toggleDropDownOpen] = useState(false);
  const [headerTitle, setHeaderTitle] = useState(title);
  const handleDropdownChange = ({ title, id }) => {
    setHeaderTitle(title);
    toggleDropDownOpen(false);
    if (id === null) {
      id = `gd_${uuidv4()}`;
    }

    sendData && sendData(id);
  };

  useEffect(() => {
    setHeaderTitle(title);
  }, [title]);

  useEffect(() => {
    setHeaderTitle(title);
  }, [isViewMode]);

  const isClient = JSON.parse(window.localStorage.userInfo || '{}')?.isClient;
  const projectPermission = useSelector(
    (state) => state.common.projectCompanyInfo?.currentUserPermission,
  );
  const isPwcReadOnly = projectPermission === projectRole['View-Only'];

  return (
    <>
      {isViewMode ? (
        <div className="dd-wrapper">
          <div className="row dd-header">
            <div
              className="dd-header-title"
              onClick={() => toggleDropDownOpen(!isDropDownOpen)}
            >
              {headerTitle}
              {/* <span className="tooltiptext">{headerTitle}</span> */}
            </div>
            <div
              className="dd-header-icon"
              onClick={() => toggleDropDownOpen(!isDropDownOpen)}
            >
              {isDropDownOpen ? (
                <span className="appkiticon icon-up-chevron-fill" />
              ) : (
                <span className="appkiticon icon-down-chevron-fill" />
              )}
            </div>
          </div>

          {isDropDownOpen && (
            <div
              className={`dropdownModal no-select ${
                isClient || isPwcReadOnly || isLeftPartEditing
                  ? 'resetClientListColor'
                  : ''
              }`}
            >
              {list.map((item) => (
                <div
                  className="dd-list-item"
                  key={item.id}
                  onClick={() => handleDropdownChange(item)}
                >
                  {item.title}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <Input
          value={title}
          maxLength={60}
          onChange={(e) => onTitleChange(e.target.value)}
        />
      )}
    </>
  );
};
